import { AgGridVue } from 'ag-grid-vue';
import 'vue-select/dist/vue-select.css';
import gql from 'graphql-tag';
import SolicitudServices from '../services/solicitud';
import CuentasPagadorasServices from '../services/cuentasPagadoras';
import PresupuestoServices from '../services/index';
import {
  ESTADOS_DETALLE_SOLICITUD,
  ESTADOS_DETALLE_SOLICITUD_OPERACION,
  OPERACIONES_DETALLE_SOLICITUD,
  TIPOS_CUENTAS_BANCARIAS,
  formatearCuentasBancarias,
  formatearValorAMoneda,
  obtenerTodasLasSedes,
  peticionCuentas1,
  peticionCuentas2,
} from '../utils';
import ConfirmacionAccion from '@/components/ConfirmacionAccion.vue';
import DetalleSolicitudService from '../services/detalle-solicitud';
import ModalRegistrarPagoDetalleSolicitud from '../components/ModalRegistrarPagoDetalleSolicitud.vue';
import previsualizacionImagenesMixin from './previsualizacion-imagenes.mixin';
import ModalVerPdf from '../components/ModalVerPdf.vue';
import ModalPrevisualizacionAdjunto from './../components/ModalPrevisualizacionAdjunto.vue';

export default {
  mixins: [previsualizacionImagenesMixin],
  components: {
    AgGridVue,
    ConfirmacionAccion,
    ModalRegistrarPagoDetalleSolicitud,
    ModalVerPdf,
    ModalPrevisualizacionAdjunto,
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        suppressMovableColumns: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtrar...',
        },
      },
      rowClassRules: null,
      gridApi: null,
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: false,
        resizable: true,
        suppressMenu: true,
      },
      dialog: false,
      enviado: false,
      errores: [],
      form: {
        id: null,
        sede_origen_id: null,
        sede_origen: null,
        sede_id: null,
        sede: null,
        numero: '',
        tipo: this.tipoSolicitud,
        total: 0,
        user_id: null,
        user: null,
        estado: null,
        detalle_solicitud: [],
      },
      agregarDetalle: {
        sede_origen: null,
        cuenta_origen: null,
        sede_destino: this.$store.state.CARGO.sede,
        cuenta_destino: null,
        detalle: null,
        saldo: 0,
        importe: '',
        clasificador: null,
      },
      cuentaOrigenItems: [],
      cuentaDestinoItems: [],
      sedeItems: [],
      partidasItems: [],
      verificar: false,
      accion: {
        titulo: '',
        mensaje: '',
        realizandoAccion: false,
      },
      estadoDetalleSolicitud: '',
      indiceDetalleSolicitudSeleccionado: null,
      observaciones: null,
      mostrarObservaciones: false,
      cargando: false,
      recuperandoArchivoAdjunto: false,
      detalleSeleccionadoId: null,
      archivoExtension: null,
      archivoMimetype: null,
    };
  },
  created() {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
    definicionColumnas() {
      return this.verificar ? this.columnDefsVerificar : this.columnDefs;
    },
    pinnedBottomRowData() {
      return [
        {
          detalle: 'TOTAL IMPORTE',
          importe: this.calcularTotal(),
          bold: true,
        },
      ];
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onRowClicked(e) {
      if (e.event.target) {
        let rowIndex = e.node.id;
        let actionType = e.event.target.getAttribute('data-action-type');

        if (actionType) {
          if (actionType == OPERACIONES_DETALLE_SOLICITUD.REMOVER) {
            this.remover(rowIndex);
          } else if (
            actionType == OPERACIONES_DETALLE_SOLICITUD.APROBAR ||
            actionType == OPERACIONES_DETALLE_SOLICITUD.RECHAZAR ||
            actionType == OPERACIONES_DETALLE_SOLICITUD.ANULAR
          ) {
            this.operacion(actionType, rowIndex);
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.RECHAZAR_MONTO) {
            this.$refs.modalRechazarMonto.abrir(this.form, rowIndex);
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.CAMBIAR_CUENTAS) {
            this.$refs.modalCambioCuentas.abrir(this.form, rowIndex);
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO) {
            this.obtenerArchivoAdjunto(this.form.detalle_solicitud[rowIndex].id);
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.REGISTRAR_PAGO) {
            this.$refs.ModalRegistrarPagoDetalleSolicitudRef.abrir(
              OPERACIONES_DETALLE_SOLICITUD.REGISTRAR_PAGO,
              this.form,
              rowIndex,
            );
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.VER_PAGO) {
            this.$refs.ModalRegistrarPagoDetalleSolicitudRef.abrir(
              OPERACIONES_DETALLE_SOLICITUD.VER_PAGO,
              this.form,
              rowIndex,
            );
          } else if (actionType == OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO_NO_SUBIDO) {
            this.$refs.modalVerPdfRef.abrir({
              extencion: this.form.detalle_solicitud[rowIndex].extension,
              mimetype: this.form.detalle_solicitud[rowIndex].mimetype,
              file64: this.form.detalle_solicitud[rowIndex].archivo,
            });
          }
        }
      }
    },
    async obtenerPartida() {
      this.agregarDetalle.saldo = this.agregarDetalle.clasificador
        ? parseFloat(this.agregarDetalle.clasificador.saldo)
        : 0;
    },
    async getCuentasDestino(id) {
      try {
        const response = await CuentasPagadorasServices.getSede(id);
        this.cuentaDestinoItems = response.data.map((cuenta) => {
          return {
            ...cuenta,
            cuenta: `${cuenta.descripcion} - ${cuenta.nombre}`,
          };
        });
      } catch (err) {
        window.console.log(err);
      }
    },
    async getCuentasOrigenMixin(id) {
      const sql = gql`query{getSede(id: ${id}) { id nombre cuentasBancarias {id nombre nro descripcion estado idsede}}}`;
      await this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          this.cuentaOrigenItems = data.data.getSede.cuentasBancarias.map((cuenta) => {
            return {
              ...cuenta,
              cuenta: `${cuenta.descripcion} - ${cuenta.nombre}`,
            };
          });
        })
        .catch((error) => {
          this.cuentaOrigenItems = [];
          window.console.log(error);
        });
    },
    async obtenerCuentasDestino() {
      // this.getCuentasDestino(this.agregarDetalle.sede_destino ? this.agregarDetalle.sede_destino.id : null);
      try {
        const id = this.agregarDetalle.sede_destino ? this.agregarDetalle.sede_destino.id : null;
        const [cuentasDestino1, cuentasDestino2] = await Promise.all([
          peticionCuentas1(id),
          peticionCuentas2(id, this.$apollo),
        ]);
        const cuentasDestino1Formateado = cuentasDestino1?.data?.datos?.map(
          formatearCuentasBancarias(TIPOS_CUENTAS_BANCARIAS.PAGADORA),
        );
        const cuentasDestino2Formateado = cuentasDestino2?.data?.getSede?.cuentasBancarias
          ? cuentasDestino2?.data?.getSede?.cuentasBancarias?.map(
              formatearCuentasBancarias(TIPOS_CUENTAS_BANCARIAS.RECAUDADORA),
            )
          : [];

        this.cuentaDestinoItems = [...cuentasDestino1Formateado, ...cuentasDestino2Formateado];
        this.agregarDetalle.cuenta_destino = null;
        this.agregarDetalle.clasificador = null;
      } catch (error) {
        window.console.log(error);
      }
    },
    async getSedes() {
      try {
        this.sedeItems = await obtenerTodasLasSedes(this.$apollo);
      } catch (error) {
        window.console.log(error);
      }
    },
    async getPartidasPresupuestosMixin(id) {
      try {
        const response = await PresupuestoServices.partidas(id);
        this.partidasItems = response.data.datos.map((partida) => ({
          id: partida.id,
          nombre: `${partida.codigo} - ${partida.nombre}`,
          codigo: partida.codigo,
          saldo: partida.saldo,
          esta_obsoleto: partida.esta_obsoleto,
        }));
      } catch (err) {
        window.console.log(err);

        this.manejoErrores(err);
      }
    },
    async registrar() {
      this.cargando = true;

      try {
        await SolicitudServices.store(this.form);
        this.actualizarListado();
        this.errores = [];
      } catch (err) {
        this.manejoErrores(err);
      } finally {
        this.cargando = false;
      }
    },
    async actualizar() {
      try {
        await SolicitudServices.update(this.form.id, this.form);
        this.actualizarListado();
        this.errores = [];
      } catch (err) {
        this.manejoErrores(err);
      }
    },
    async revisar() {
      try {
        await SolicitudServices.revisar(this.form.id, this.form);
        this.actualizarListado();
        this.errores = [];
      } catch (err) {
        this.manejoErrores(err);
      }
    },
    manejoErrores(error) {
      const response = error?.response;
      const status = response?.status;
      const data = response?.data;
      const mensaje = data?.mensaje;
      const errores = data?.errores;
      this.dialog = true;
      this.enviado = false;
      this.errores = errores;
      const erroresFormateados =
        errores instanceof Object
          ? Object.values(errores)
              .map((error) => error.join(', '))
              .join('<br>')
          : errores;

      if (status === 422) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: errores ? erroresFormateados : 'Ocurrió un error al procesar la solicitud',
          type: 'error',
        });
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al procesar la solicitud',
          type: 'error',
        });
      }
    },
    calcularTotal() {
      let resultado = 0;
      for (let index = 0; index < this.form.detalle_solicitud.length; index++) {
        resultado = resultado + parseFloat(this.form.detalle_solicitud[index].importe);
      }
      resultado = resultado.toFixed(2);
      this.form.total = parseFloat(resultado);

      return resultado;
    },
    cerrarModal() {
      if (this.verificar) {
        this.actualizarListado();
      }

      this.dialog = false;
    },
    remover(index) {
      this.form.detalle_solicitud.splice(index, 1);
    },
    validar() {
      if (this.form.detalle_solicitud.length > 0) {
        if (!this.enviado) {
          this.enviado = true;
          if (!this.verificar) {
            if (this.form.id) {
              this.actualizar();
            } else {
              this.registrar();
            }
          } else {
            this.revisar();
          }
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe agregar al menos un detalle de solicitud',
          type: 'error',
        });
      }
    },
    actualizarListado() {
      this.form.id = null;
      this.$emit('actualizarListado');
      this.dialog = false;
      this.enviado = false;
    },
    async aceptarAccion() {
      if (
        this.estadoDetalleSolicitud === ESTADOS_DETALLE_SOLICITUD.APROBADO ||
        this.estadoDetalleSolicitud === ESTADOS_DETALLE_SOLICITUD.RECHAZADO ||
        this.estadoDetalleSolicitud === ESTADOS_DETALLE_SOLICITUD.ANULADO
      ) {
        await this.procesar(this.indiceDetalleSolicitudSeleccionado, this.estadoDetalleSolicitud);
      }
    },
    cerrarAccion() {
      this.observaciones = null;
    },
    operacion(tipoAccion, index) {
      this.mostrarObservaciones = [
        OPERACIONES_DETALLE_SOLICITUD.RECHAZAR,
        OPERACIONES_DETALLE_SOLICITUD.ANULAR,
      ].includes(tipoAccion);
      this.estadoDetalleSolicitud = ESTADOS_DETALLE_SOLICITUD_OPERACION[tipoAccion];
      this.indiceDetalleSolicitudSeleccionado = index;
      const detalleSolicitud = this.form.detalle_solicitud[index];
      this.accion.titulo = `${tipoAccion.toUpperCase()} DETALLE DE SOLICITUD`;
      this.accion.mensaje = /*html*/ `¿ESTÁ SEGURO DE ${tipoAccion.toUpperCase()} EL DETALLE DE SOLICITUD?
        <br><strong>BANCO ORIGEN</strong>: ${detalleSolicitud.banco_origen}
        <br><strong>CUENTA ORIGEN</strong>: ${detalleSolicitud.cuenta_origen}
        <br><strong>SEDE DESTINO</strong>: ${detalleSolicitud.sede_destino}
        <br><strong>BANCO DESTINO</strong>: ${detalleSolicitud.banco_destino}
        <br><strong>CUENTA DESTINO</strong>: ${detalleSolicitud.cuenta_destino}
        <br><strong>CUENTA</strong>: ${detalleSolicitud.clasificador}
        <br><strong>CONTABLE</strong>: ${detalleSolicitud.cuenta_contable}
        <br><strong>DETALLE</strong>: ${detalleSolicitud.detalle}
        <br><strong>IMPORTE</strong>: ${detalleSolicitud.importe}`;

      this.$refs.confirmacionAccion.abrir();
    },
    async procesar(indiceDetalleSolicitud, estadoDetalleSolicitud) {
      if (
        [ESTADOS_DETALLE_SOLICITUD.RECHAZADO, ESTADOS_DETALLE_SOLICITUD.ANULADO].includes(estadoDetalleSolicitud) &&
        !this.observaciones
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe ingresar una observación',
          type: 'error',
        });

        return;
      }

      this.accion.realizandoAccion = true;

      try {
        const id = this.form.detalle_solicitud[indiceDetalleSolicitud].id;

        await DetalleSolicitudService.procesar(id, {
          estado: estadoDetalleSolicitud,
          observaciones: this.observaciones,
        });

        this.form.detalle_solicitud[indiceDetalleSolicitud].estado = estadoDetalleSolicitud;
        this.gridApi.refreshCells();

        this.$notify({
          group: 'notifications',
          title: 'DETALLE DE SOLICITUD PROCESADO CORRECTAMENTE',
          text: 'Exito',
          type: 'success',
        });

        this.$refs.confirmacionAccion.cerrar();
      } catch (error) {
        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: error.response.data.mensaje,
          type: 'error',
        });
      } finally {
        this.accion.realizandoAccion = false;
      }
    },
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
    async obtenerPartidaSaldo(sede_id, clasificador_id, indice) {
      const [response, response1] = await Promise.all([
        SolicitudServices.getNacPartida(sede_id, clasificador_id),
        PresupuestoServices.getPartida(sede_id, clasificador_id),
      ]);

      this.form.detalle_solicitud[indice].saldo = parseFloat(response1.data.datos) - parseFloat(response.data.datos);
    },
    async obtenerArchivoAdjunto(detalleId) {
      this.detalleSeleccionadoId = detalleId;
      this.recuperandoArchivoAdjunto = true;
      this.gridApi?.refreshCells();

      try {
        const { data } = await DetalleSolicitudService.obtenerArchivoAdjunto(detalleId);
        const { datos } = data;

        this.$refs.modalVerPdfRef.abrir(datos);
      } catch (error) {
        window.console.log(error);
        const mensaje = error.response.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al obtener el archivo adjunto',
          type: 'error',
        });
      } finally {
        this.recuperandoArchivoAdjunto = false;
        this.detalleSeleccionadoId = null;
        this.gridApi?.refreshCells();
      }
    },
    verPrevisualizacion() {
      this.$refs.modalPrevisualizacionAdjuntoRef.abrir(this.previsualizacion, this.esImagen, this.esPDF);
    },
  },
};
